export const checkObjectHasEmptyProperty = (
  object: Record<string, any> | null | undefined,
): boolean => {
  if (!object || !Object.keys(object).length) {
    return true;
  }

  return Object.values(object).some((value) => {
    if (typeof value === 'object') {
      return checkObjectHasEmptyProperty(value);
    }

    return value === null || value === undefined || value === '';
  });
};
